var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen }
    },
    [
      _c("div", { staticClass: "mobile-menu-header" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              loading: "lazy",
              width: "240",
              height: "54",
              src:
                _vm.pluginPath + "/images/Logo_sweets-online_Desktop_2019.png"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "menu-toggle pull-right",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.closeNavigation()
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-close",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-menu" }, [
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu menu-active",
            attrs: { id: "menu-1" }
          },
          [
            _vm.dataContainer1.parent
              ? _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer1.parent &&
                            _vm.dataContainer1.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "nav-direction btn-up" }, [
                      _vm._v(
                        "\n                        Zurück\n                    "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dataContainer1.parent,
                    expression: "dataContainer1.parent"
                  }
                ],
                staticClass: "mobile-navigation-menu__item"
              },
              [
                _c("a", { attrs: { href: _vm.parentUrl } }, [
                  _vm._v(
                    "\n                        Alle Produkte\n                    "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.dataContainer1.categories, function(category) {
              return _c(
                "li",
                {
                  staticClass: "ddown",
                  class: { "li-node": category.childCount }
                },
                [
                  category.childCount
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(category.details[0].name) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !category.children && category.details[0]
                    ? _c("a", { attrs: { href: category.url } }, [
                        _vm._v(_vm._s(category.details[0].name))
                      ])
                    : _vm._e()
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu",
            attrs: { id: "menu-2" }
          },
          [
            _vm.dataContainer1.parent
              ? _c(
                  "li",
                  {
                    staticClass: "ddown",
                    on: {
                      click: function($event) {
                        return _vm.slideTo(
                          (_vm.dataContainer1.parent &&
                            _vm.dataContainer1.parent.parent) ||
                            null,
                          true
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "nav-direction btn-up" }, [
                      _vm._v(
                        "\n                        Zurück\n                    "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataContainer1.parent
              ? _c("li", { staticClass: "mobile-navigation-menu__item" }, [
                  _c("a", { attrs: { href: _vm.parentUrl } }, [
                    _vm._v(
                      "\n                        Alle Produkte\n                    "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dataContainer2.categories, function(category) {
              return _c(
                "li",
                {
                  staticClass: "ddown",
                  class: { "li-node": category.childCount }
                },
                [
                  category.childCount
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(category.details[0].name) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !category.children && category.details[0]
                    ? _c("a", { attrs: { href: category.url } }, [
                        _vm._v(_vm._s(category.details[0].name))
                      ])
                    : _vm._e()
                ]
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }